import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/Icon_BetterAperture.png'
import _imports_1 from '../assets/Screenshot_BetterAperture_1.png'
import _imports_2 from '../assets/Screenshot_BetterAperture_2.png'
import _imports_3 from '../assets/Screenshot_BetterAperture_3.png'
import _imports_4 from '../assets/Screenshot_BetterAperture_4.png'
import _imports_5 from '../assets/Screenshot_BetterAperture_5.png'
import _imports_6 from '../assets/Screenshot_BetterAperture_6.png'
import _imports_7 from '../assets/Screenshot_BetterAperture_7.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_column = _resolveComponent("ion-column")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("BetterAperture", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("BetterAperture", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "column-standard2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "bannerColumn" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "auto" }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "icon"
                      }, null, -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "auto",
                    class: "description-column"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { style: {"padding":"0px","margin":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, { style: {"padding":"0px","margin":"0px"} }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createElementVNode("p", {
                                class: "size-appname",
                                style: {"padding":"0px","margin":"0px"}
                              }, [
                                _createElementVNode("strong", null, "BetterAperture")
                              ], -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, null, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("p", { class: "size-appname-icon" }, "version 1.0.0", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.logoAndroid,
                                class: "size-appname-icon"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        href: "https://cdn.puffercat.xyz/c/puffercat-apps/apks/BetterAperture/betteraperture-1.0.0.apk",
                        expand: "full",
                        shape: "round",
                        style: {"margin":"0px"},
                        download: "BetterAperture-latest.apk"
                      }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("Download", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Changelog - 1.0.0")
                      ], -1),
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, "Initial release")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Description")
                      ], -1),
                      _createTextVNode(" The app cointains 100+ icons designed to replace the ugly icon of the LineageOS camera.", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" If your launcher supports manual icon selection, you can also apply the icons to other camera apps.", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" If you want to use a different icon than the default one with a launcher that doesn't support manual icon selection, check for a single icon variant here: ", -1),
                      _createElementVNode("a", { href: "https://github.com/KZacharski/BetterAperture/wiki/Single-icon-packages" }, "https://github.com/KZacharski/BetterAperture/wiki/Single-icon-packages", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" Included icon categories:", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" - Gradient", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" - Duotone", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" - Aosp", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" - Flat", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" - Classic", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" Join the support group on Telegram: ", -1),
                      _createElementVNode("a", { href: "https://puffercatrom.t.me" }, "https://puffercatrom.t.me", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Screenshots")
                      ], -1),
                      _createElementVNode("div", { class: "scrollScreenshots" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_2,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_3,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_5,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_7,
                          class: "screenshot"
                        })
                      ], -1),
                      _createElementVNode("br", null, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Links")
                      ], -1),
                      _createElementVNode("a", {
                        href: "https://github.com/KZacharski/BetterAperture/wiki/Single-icon-packages",
                        class: ""
                      }, "Single icon packages", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "mailto:puffercatt+betteraperture@gmail.com",
                        class: ""
                      }, "E-mail", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://cdn.puffercat.xyz/c/betteraperture/privacy",
                        class: ""
                      }, "Privacy policy", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://pufferrom.t.me",
                        class: ""
                      }, "Telegram channel (releases)", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://puffercatchannel.t.me",
                        class: ""
                      }, "Telegram channel (general)", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://puffercatrom.t.me",
                        class: ""
                      }, "Support group", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://github.com/KZacharski/BetterAperture",
                        class: ""
                      }, "GitHub repo", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}